import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=d45dee86&scoped=true&"
import script from "./shortcut.vue?vue&type=script&lang=js&"
export * from "./shortcut.vue?vue&type=script&lang=js&"
import style0 from "./shortcut.vue?vue&type=style&index=0&id=d45dee86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45dee86",
  null
  
)

export default component.exports